module.exports = __webpack_public_path__ + "static/media/gongzhonghao.b44a6659.jpg";